<script setup>
import { subStringToType } from '@/utils/index'
import useOrder from './hooks/useOrder'
import { computed, onMounted, ref, watch, onUnmounted, nextTick, defineProps, reactive } from 'vue'
import GroupOrderItem from './components/GroupOrderItem.vue'
import Transfer from '../Transfer/index.vue'
import TheDetail from '@/components/TheDetail/index.vue'
import ADetail from '../Appoint/index.vue'
import OrderTab from './components/OrderTab.vue'
import workOrderType from '@/views/hooks/workorderType'
import TodoList from './components/TodoList/TodoList.vue'
import pendingList from './components/pendingList.vue'
import { getPageCallAiChatSummary, getStateByWorkOrderId } from '@/api/workPlace/workOrder'
import { message } from 'ant-design-vue'
import { useStore } from 'vuex'
import EncourageModal from '@/components/EncourageModal'
import {
  REFRESH_LIST,
  CLOSE_CURRENT_IM,
  INIT_ORDER_SORT_STATUS
} from '@/views/WorkPlace/handleEventBuss'
import { initWorkOrder } from '@/views/WorkPlace/hooks/workOrder.js'
import { computeGroupId } from './components/hooks/useGroupOrder'
import { getTodoList } from '@/api/Todo'

const store = useStore()
const props = defineProps({
  activeKey: {
    type: Number,
    default: 2,
    required: false
  }
})
watch(
  () => props.activeKey,
  val => {
    orders.activeKey = +val
  }
)
// *工单方法类
const {
  orders,
  bench,
  onResetFetch,
  getOrders,
  scrollBottom,
  handleTop,
  toppingList,
  curTopList,
  erpId,
  guideConsultList,
  guideConsultIds,
  fastTrack,
  showEncourage,
  orderDOM,
  searchHangupOrder,
  refreshOrderList,
  searchCloseToRoll,
  handleChangeRealTimeOrder,
  initSortStatus
} = useOrder()
const todoListVisible = computed(() => store.state.workOrder.todoListVisible)
function doPendingItNow() {
  orders.activeKey = 3
  onResetFetch()
}
// 处理中工单点击立即处理
function doItNow({ res, reload = undefined }) {
  if (!res) return
  orders.activeKey = 3
  // NOTE:点击立即处理必须要刷新列表 立即处理，转交
  reload && onResetFetch()
  store.commit('app/SET_TABS_ACTIVE', 'Chat')
  store.dispatch('rollBack/getAllRefreshTimer')
}

const hasList = computed(() => {
  if (orders.activeKey === 3) {
    return orders.processList.length
  } else {
    const pendingWorkOrder = orders.pendList?.pendingWorkOrder || {}
    const waitingForAllotWorkOrderList = orders.pendList?.waitingForAllotWorkOrderList || []
    return pendingWorkOrder.workOrderId || waitingForAllotWorkOrderList.length
  }
})
onMounted(() => {
  getOrders()
  getTodoListVisible()
  orderDOM.value.addEventListener('scroll', scrollBottom)
  const obj = JSON.parse(localStorage.getItem('TOP_LIST')) || {}
  curTopList.value = obj[erpId.value] || []
  REFRESH_LIST?.on(refreshOrderList)
  CLOSE_CURRENT_IM?.on(initWorkOrder)
  INIT_ORDER_SORT_STATUS?.on(initSortStatus)
})
onUnmounted(() => {
  REFRESH_LIST?.off()
  CLOSE_CURRENT_IM?.off()
  INIT_ORDER_SORT_STATUS?.off()
  if (orderDOM.value) orderDOM.value.removeEventListener('scroll', scrollBottom)
})
const serialNumber = ref('')
const visibleDetail = ref(false)
function openDetail(e) {
  serialNumber.value = e
  visibleDetail.value = true
}

const aDetail = ref(null)
const reserveSn = ref('')
const openAppoint = val => {
  reserveSn.value = val.toString()
  nextTick(() => {
    aDetail.value.mVisible = true
    aDetail.value.initDetail()
  })
}

// 转交工单
const transferInfo = reactive({
  showTransfer: false,
  transferId: 0,
  ucDoctorId: '',
  ucPatientId: ''
})
function openTransfer(item) {
  const { workOrderId, ucPatientId, ucDoctorId } = item
  getStateByWorkOrderId({ workOrderId }).then(res => {
    if (res === 200) {
      message.error('工单已完成，无法转交')
      refreshOrderList()
    } else {
      transferInfo.showTransfer = true
      transferInfo.transferId = workOrderId
      transferInfo.ucDoctorId = ucDoctorId
      transferInfo.ucPatientId = ucPatientId
    }
  })
}
watch(
  () => orders.searchType,
  () => {
    orders.name = null
  }
)
// 在处理中工单中过滤掉已经置顶的工单
const showOrder = item => {
  const { groupId, guideConsultGroupId, doctorDaGroupId } = item
  const arr = [...guideConsultIds.value, ...curTopList.value]
  const curID = groupId || guideConsultGroupId || doctorDaGroupId
  // 导诊群改版需要通过groupType过滤掉导诊群
  const show = !arr.includes(curID) && item.groupType !== 3
  // 处方代购工单 置顶也需要过滤
  const pinTop = orders.realTimeOrderList.map(v => v.value)
  const isPinTop = item.businessTypeList.some(v => pinTop.includes(v))
  return show && !isPinTop
}
const goTop = () => {
  orderDOM.value.scrollTop = 0
}
const goBottom = () => {
  const scrollHeight = orderDOM.value.scrollHeight
  const clientHeight = orderDOM.value.clientHeight

  if (scrollHeight > clientHeight) {
    setTimeout(function () {
      //设置滚动条到最底部
      orderDOM.value.scrollTop = scrollHeight
    }, 0)
  }
}
// 获取通话小结列表数据
const getTodoListVisible = async () => {
  try {
    const params = {
      pageNo: 1,
      pageSize: 999
    }
    const res = await getPageCallAiChatSummary(params)
    store.dispatch('workOrder/setTodoListState', res?.list || [])
  } catch (error) {
    console.log(error)
  }
}
</script>

<template>
  <!-- 待办列表 -->
  <div class="work-order">
    <!-- 头部 tab 切换 -->
    <order-tab v-model:activeKey="orders.activeKey" :tabs="bench.tabs" @tabClick="onResetFetch" />
    <!-- 查询 -->
    <div class="search-box" v-if="orders.activeKey === 3">
      <a-input-group class="group_search" compact>
        <a-select class="search-select" v-model:value="orders.searchType">
          <a-select-option :value="1">医生/患者</a-select-option>
          <a-select-option :value="2">工单id</a-select-option>
          <a-select-option :value="3">工单类型</a-select-option>
        </a-select>
        <a-input
          v-if="[1, 2].includes(orders.searchType)"
          class="search-input"
          :maxlength="orders.searchType === 1 ? 20 : 19"
          v-model:value.trim="orders.name"
          @keydown.enter="getOrders"
        ></a-input>
        <a-select
          v-else
          class="search-input"
          v-model:value="orders.name"
          placeholder="工单类型"
          allowClear
          @change="getOrders"
        >
          <a-select-option
            v-for="option in workOrderType"
            :value="option.eventType"
            :key="option.eventType"
          >
            {{ option.eventTypeContent }}
          </a-select-option>
        </a-select>
      </a-input-group>
      <div class="search-hungup">
        <div
          @click="searchHangupOrder(!orders.manualSuspendFlag, 0)"
          :class="{ actived: orders.manualSuspendFlag, chooseDiv: true }"
        >
          {{ `手动挂起(${orders.manualNum}/${orders.workOrderSuspendNumberLimit})` }}
        </div>
        <div
          class="search-hungup_right"
          @click="searchHangupOrder(!orders.autoSuspendFlag, 1)"
          :class="{ actived: orders.autoSuspendFlag, chooseDiv: true }"
        >
          {{ `自动挂起(${orders.autoNum})` }}
        </div>
        <!-- <div
          @click="searchHangupOrder(!orders.suspendFlag)"
          :class="{ actived: orders.suspendFlag }"
        >
          已挂起工单
        </div> -->
        <div
          class="search-hungup_right"
          :class="{
            slectActived: Boolean(orders.realTimeFlag),
            chooseDiv: true,
            searchWithSelect: true
          }"
        >
          <a-select
            style="width: 82px"
            allowClear
            v-model:value="orders.realTimeOrder"
            placeholder="即时工单"
            :options="orders.realTimeOrderList"
            @change="handleChangeRealTimeOrder"
          />
        </div>
        <div
          @click="searchCloseToRoll(!orders.rollBackSort)"
          :class="{ actived: orders.rollBackSort, chooseDiv: true }"
        >
          临回滚工单
        </div>
      </div>
    </div>
    <!-- 展示 -->
    <div :class="[{ 'pending-list': orders.activeKey === 2 }, 'work-list']">
      <template v-if="orders.activeKey === 3">
        <div class="jump_btn go_up" @click="goTop" v-show="fastTrack.up.visible">
          <auth-img :src="fastTrack.up.src" />
          <span>返回顶部</span>
        </div>
        <div class="jump_btn go_down" @click="goBottom" v-show="fastTrack.down.visible">
          <auth-img :src="fastTrack.down.src" />
          <span>查看底部</span>
        </div>
      </template>
      <!-- 通话小结待办 -->
      <todo-list v-if="orders.activeKey === 2 && todoListVisible" />
      <a-spin class="spinning" :spinning="bench.loading">
        <ul v-show="hasList" class="work-order_list" ref="orderDOM" style="padding-bottom: 30px">
          <!-- 导诊咨询工单全部置顶 -->
          <template v-if="orders.activeKey === 3 && guideConsultList.length">
            <li
              class="work-order_list-item top-list"
              v-for="item in guideConsultList"
              :key="item.groupId"
            >
              <GroupOrderItem
                @doItNow="doItNow"
                v-bind="$attrs"
                :info="item"
                :isTop="true"
                :isGuide="true"
              />
            </li>
          </template>
          <!-- 手动置顶的工单 -->
          <template v-if="orders.activeKey === 3 && toppingList.length">
            <li
              class="work-order_list-item top-list"
              v-for="item in toppingList"
              :key="item.groupId"
            >
              <GroupOrderItem
                @handleTop="handleTop"
                @doItNow="doItNow"
                v-bind="$attrs"
                :info="item"
                :isTop="true"
              />
            </li>
          </template>
          <!-- 待处理工单 -->
          <template v-if="orders.activeKey === 2 && orders.pendList">
            <pendingList
              @doPendingItNow="doPendingItNow"
              @openDetail="openDetail"
              @openAppoint="openAppoint"
              @openTransfer="openTransfer"
              @receiveOrder="onResetFetch"
              :showDoIt="bench.showDoIt"
              v-bind="$attrs"
              :data="orders.pendList"
            />
          </template>
          <!-- 处理中工单 -->
          <template v-if="orders.activeKey === 3">
            <li
              class="work-order_list-item"
              v-for="item in orders.processList"
              :key="
                computeGroupId(
                  item.guideConsultGroupId,
                  item.groupId,
                  item.doctorDaGroupId,
                  item.assistantPatientGroupId,
                  item.groupType
                )
              "
            >
              <!-- 在处理中工单中过滤掉已经置顶的工单 -->
              <GroupOrderItem
                @handleTop="handleTop"
                @doItNow="doItNow"
                :info="item"
                v-bind="$attrs"
                v-if="showOrder(item)"
              />
            </li>
          </template>
        </ul>
        <!-- 没有工单数据 !hasList-->
        <div v-show="!hasList" class="work-order_list-null z-flex-c">暂无待办的日子,休息一下~</div>
      </a-spin>
    </div>
    <!-- 转交 -->
    <transfer
      @onCancel="onResetFetch"
      v-model:visible="transferInfo.showTransfer"
      :transferInfo="transferInfo"
    />
    <!-- 详情 -->
    <the-detail
      v-model:visible="visibleDetail"
      :recordType="subStringToType(serialNumber)"
      :serialNumber="serialNumber"
      id="0"
    />
    <ADetail ref="aDetail" :reserveSn="reserveSn" />
    <EncourageModal v-model:visible="showEncourage" />
  </div>
</template>
<style lang="scss" scoped>
.work-order {
  width: 304px;
  box-shadow: 2px 2px 6px 0 rgba(181, 198, 229, 0.15);
  height: 100%;

  .search-box {
    background: white;
    text-align: center;
    padding: 8px 12px;

    .group_search {
      padding: 0;
      width: 100%;
      display: inline-block;

      .search-select {
        width: 104px;

        ::v-deep(.ant-select-selector) {
          background-color: #f5f7f9;
        }
      }

      .search-input {
        width: calc(100% - 104px);
        background-color: #f5f7f9;
      }
    }

    .search-hungup {
      display: flex;
      // justify-content: space-between;
      text-align: left;
      flex-wrap: wrap;

      .chooseDiv {
        padding: 4px 6px;
        border-radius: 4px;
        font-size: 12px;
        border: 1px solid #e3e3e3;
        color: #333333;
        width: fit-content;
        cursor: pointer;
        line-height: initial;
        margin-top: 6px;
      }

      .actived {
        background: #0084ff14;
        color: #1890ff;
        border: 1px solid #0084ff14;
      }

      .search-hungup_right {
        margin-left: 6px;
        ::v-deep(.ant-select-selection-placeholder) {
          color: #333333;
        }
      }

      .searchWithSelect {
        display: flex;
        align-items: center;
        padding: 0;
        height: 27px;

        ::v-deep(.ant-select-selector) {
          width: 100%;
          font-size: 12px;
          display: flex;
          align-items: center;
          border: none;
          padding-right: 0;
          padding-left: 10px;
          height: 25px;
        }
        ::v-deep(.ant-select-single .ant-select-show-arrow .ant-select-selection-item) {
          height: 20px;
        }

        ::v-deep(.ant-select-arrow) {
          font-size: 10px;
        }
      }

      .slectActived {
        ::v-deep(.ant-select-selector) {
          background: #0084ff14;
          color: #1890ff;
        }
      }
    }
  }

  .work-list {
    background: white;
    width: 100%;
    height: calc(100vh - 188px);

    &.pending-list {
      height: calc(100vh - 108px);

      .work-order_list,
      .work-order_list-null {
        height: calc(100vh - 108px);
      }
    }

    .work-order_list,
    .work-order_list-null {
      height: calc(100vh - 188px);
    }

    position: relative;

    .jump_btn {
      position: absolute;
      padding: 5px 10px;
      cursor: pointer;
      right: 12px;
      background: #ffffff;
      box-shadow: 0 1px 6px 0 #0000001a;
      border-radius: 13px;
      z-index: 10;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      display: flex;
      line-height: initial;

      img {
        width: 16px;
        height: 16px;
      }

      &.go_up {
        top: 16px;
      }

      &.go_down {
        bottom: 36px;
      }
    }

    .spinning {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .work-order_list {
      padding: 0;
      list-style: none;
      overflow: auto;
      background: #ffffff;

      &-item {
        position: relative;

        &:last-child {
          border-bottom: none;
        }
      }
    }

    .work-order_list-null {
      text-align: center;
      justify-content: center;
    }
  }
}
</style>
